import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import type { CreateCSSProperties, CSSProperties } from '@mui/styles';

type StylesProps = {
  buttonBackgroundColor: CSSProperties['backgroundColor'],
  buttonHoverColor: CSSProperties['backgroundColor'],
  buttonBorderColor: CSSProperties['backgroundColor'],
  textColor?: CSSProperties['backgroundColor'],
  width?: CSSProperties['width']
  height?: CSSProperties['height']
  iconOnly?: boolean
}

export const useStyles = makeStyles((theme: Theme) => {
  const iconFontSize = '16px';
  const classes = createStyles({
    text: {
      textTransform: 'none',
      color: (props: StylesProps) => (props.textColor ?? theme.palette.primary.main),
      fontWeight: 500,
      textAlign: 'center'
    },
    icon: {
      fontSize: iconFontSize,
      marginRight: theme.spacing(1),
    },
    iconOnly: {
      fontSize: iconFontSize,
      marginRight: 0,
    },
    button: (props: StylesProps) => {
      let styles: CreateCSSProperties = {};
      if (props.buttonBorderColor) {
        styles.borderColor = props.buttonBorderColor;
      }

      if (props.buttonBackgroundColor) {
        styles = {
          ...styles,
          backgroundColor: props.buttonBackgroundColor,
          '&:hover': {
            backgroundColor: props.buttonHoverColor ?? props.buttonBackgroundColor,
            color: props.textColor ?? theme.palette.primary.main,
          },
        };
      }

      if (props.width) {
        styles.width = props.width;
      }

      if (props.height) {
        styles.height = props.height;
      }

      if (props.iconOnly) {
        styles.minWidth = 0;
        styles.padding = 0;
      }

      return styles;
    }
  });

  return classes;
});
